import { IFooterLinkItem } from "design-system/src/Navigation/Footer/FooterWidget/FooterLinks/FooterLinks";
import { IconName } from "design-system/src/lib/svgIcon/components";
import {
  GATSBY_CONF_FACEBOOK_URL,
  GATSBY_CONF_INSTAGRAM_URL,
  GATSBY_CONF_LINKEDIN_URL,
  GATSBY_CONF_PINTEREST_URL,
  GATSBY_CONF_TIKTOK_URL,
} from "@src/utils/constants";
//
//
//
const links: IFooterLinkItem[] = [
  { id: "facebook", url: GATSBY_CONF_FACEBOOK_URL },
  { id: "instagram", url: GATSBY_CONF_INSTAGRAM_URL },
  { id: "tiktok", url: GATSBY_CONF_TIKTOK_URL },
  { id: "pinterest", url: GATSBY_CONF_PINTEREST_URL },
  { id: "linkedin", url: GATSBY_CONF_LINKEDIN_URL },
]
  .filter((link) => !!link.url)
  .map(({ id: social, url }) => {
    const icon = `logo_${social}` as IconName;
    const label = social.charAt(0).toUpperCase() + social.slice(1);
    return {
      url,
      label,
      icon: icon,
      targetBlank: true,
    };
  });
//
const useSocialLinks = (): IFooterLinkItem[] => {
  return links;
};

export default useSocialLinks;
